export const environment = {
  production : false,
  apiBase    : 'https://api.realstate.wjavadev.com.mx/api',
  //apiBase    : 'https://api.sistemadyg.com/api',
  //apiBase    : 'http://127.0.0.1:8080/api',
  verificationBaseUrl: 'https://verification.dev.sistemadyg.com.mx',
  jwtSecret  : '462D4A614E645261176B586E3272357538782F413F4428472B4B6250655368566D5900YBX33676397924422645294840KO635166546A576E5A7234753777217A',
  recaptchaSiteKey : '6Ld_1OUqAAAAAOsnvVtJZsrOK_wSTOSxnAuLgyhW',
  googleMapsKey: 'AIzaSyA4o862P7Sk7uNuBs5SPMHZdpLff0jvbEE',
};
